import HeaderSpan from './HeaderSpan'
import BaliseItem from './BaliseItem'
import { langBaliseList } from '../assets/langBaliseList'
import { useLang } from '../utils/hooks'
import { textClass } from '../assets/colors'

const BaliseList = ({
  list,
  handleSelectNewItem,
  handleSort,
  handleSearchInputChange,
  handleEscSearch,
}) => {
  const { lang } = useLang()
  const choosenLang = lang === 'eng' ? langBaliseList.eng : langBaliseList.fr

  const w_a = ['35', '15', '10', '20', '25']

  const listBalises = list.listPage
  const sortOrder = list.sortOrder.isReverse
  const sortType = list.sortOrder.sortType
  const searchInput = list.searchInput

  const on_sort = (columnType) => {
    handleSort(columnType)
  }

  const handle_click_on_item = (event) => {
    let item_id = isNaN(parseInt(event.target.id))
      ? event.target.id
      : parseInt(event.target.id)
    const item = listBalises.filter((balise) => item_id === balise.baliseId)[0]
    handleSelectNewItem(item)
  }

  const onSearchInputChange = (event) => {
    handleSearchInputChange(event)
  }

  const onKey = (e) => {
    if (e.key === 'Escape') handleEscSearch()
  }

  let i = 0
  let row_i = 0

  const balises = listBalises.map((one_balise, index) => {
    row_i++
    return (
      <BaliseItem
        key={index}
        balise={one_balise}
        on_click={handle_click_on_item}
        is_grey={row_i % 2 === 1}
        is_selected={one_balise.bg}
        w_a={w_a}
      ></BaliseItem>
    )
  })

  return (
    <div className="content">
      <div className="level">
        <div className="level-left"></div>
        <div className="level-right">
          <div className="level-item">
            <div className="field is-horizontal">
              <div className="field-label is-small">
                <label className="label">{choosenLang.search} </label>
              </div>
              <div className="field-body">
                <div className="field">
                  <p className="control">
                    <input
                      className="input is-small"
                      type="search"
                      value={searchInput}
                      onChange={onSearchInputChange}
                      onKeyDown={onKey}
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={'block ' + textClass}>
        <div style={{ display: 'flex', width: '100%' }}>
          <HeaderSpan
            headerTitle={choosenLang.name}
            columnType={'NAME_SORT'}
            sortType={sortType}
            sortOrder={sortOrder}
            w={w_a[i]}
            handleOnClick={on_sort}
            align={'left'}
          />
          <HeaderSpan
            headerTitle={choosenLang.id}
            columnType={'ID_SORT'}
            sortType={sortType}
            sortOrder={sortOrder}
            w={w_a[++i]}
            handleOnClick={on_sort}
            align={'left'}
          />
          <HeaderSpan
            headerTitle={choosenLang.dataDispo}
            columnType={''}
            w={w_a[++i]}
            align={'center'}
          />
          <HeaderSpan
            headerTitle={choosenLang.alt}
            columnType={'ALT_SORT'}
            showSortArrows={true}
            sortType={sortType}
            sortOrder={sortOrder}
            w={w_a[++i]}
            handleOnClick={on_sort}
            align={'center'}
            clickEnabled={true}
          />
          <HeaderSpan
            headerTitle={choosenLang.dist}
            columnType={'DIST_SORT'}
            showSortArrows={true}
            sortType={sortType}
            sortOrder={sortOrder}
            w={w_a[++i]}
            handleOnClick={on_sort}
            align={'center'}
            clickEnabled={true}
          />
        </div>
      </div>

      <div className={'block ' + textClass}>{balises}</div>
    </div>
  )
}

export default BaliseList
